import { Controller } from "@hotwired/stimulus"
import { useClickOutside, useWindowResize } from 'stimulus-use'
import MobileSwipeMenu from "mobile-swipe-menu"
import { isMobileApp } from "../packs/global/utils"

// Connects to data-controller="sidedrawer"
export default class extends Controller {
  static targets = ["sidedrawer"];

  connect() {
    this.windowWidth = window.innerWidth;
    this.mobileSidedrawerSize = "70vw";

    useWindowResize(this)
    if (isMobileApp) {
      this.initMobileSwipeMenu()
    }
    if (this.needsToListenToClickOutside) {
      useClickOutside(this, { element: this.sidedrawer, onlyVisible: true });
    }
  }

  initMobileSwipeMenu() {
    this.mobileMenu = new MobileSwipeMenu(this.sidedrawer, {
      mode: "left",
      width: window.innerWidth * 0.7,
      enableBodyHook: false,
      events: {
        opened: () => this.showBackdrop(),
        closed: () => this.hideBackdrop(),
      },
    })
    // Das Library setzt z-index inline auf 1000 -- unser SCSS-Wert (1100) soll
    // wieder greifen, damit der Drawer über Bootstrap-Toasts (1090) liegt.
    this.sidedrawer.style.zIndex = ""
  }

  windowResize({ width }) {
    this.windowWidth = width;
    if (this.mobileMenu) {
      this.mobileMenu.setWidth(width * 0.7)
    }
    if (this.needsToListenToClickOutside) {
      useClickOutside(this, { element: this.sidedrawer, onlyVisible: true });
    }
  }

  openLink(event) {
    const href = event.target.closest('.sidedrawer-link').dataset.href

    const shouldOpenInNewTab = event.metaKey || event.ctrlKey || event.shiftKey;
    if (shouldOpenInNewTab) {
      window.open(href, '_blank');
      return;
    }

    if (isMobileApp) {
      this.openLinkWithTimeout(href);
    } else {
      Turbo.visit(href);
    }
  }

  openLinkWithTimeout(href) {
    this.closeMobileVersion();
    // Library animiert den Close über 300ms -- mit display:none wird der Drawer
    // sofort ausgeblendet, damit der HotwireNative-Cache-Screenshot ihn nicht mehr sieht.
    this.sidedrawer.style.display = "none";

    // Wenn der Link zu früh aufgerufen wird, ist der Sidedrawer noch nicht geschlossen wenn HotwireNative ein cache-screenshot macht.
    // Dies führt beim zurücknavigieren zu einem "flackern".
    // Hack: Durch das setTimeout sicherstellen, dass der Sidedrawer geschlossen ist, bevor der Link aufgerufen wird.
    setTimeout(() => {
      Turbo.visit(href)
    }, 40);
  }

  toggleDesktopVersion() {
    document.querySelector('#top-bar-logo').classList.toggle('image-hidden');
    document.querySelector('body').classList.toggle('hidden-sidedrawer');
  }

  toggleMobileVersion() {
    // openLinkWithTimeout setzt display:none damit der Cache-Screenshot den Drawer nicht zeigt.
    // Beim Zurücknavigieren (z.B. Android Fragment-Wechsel) bleibt das gesetzt — hier zurücksetzen.
    this.sidedrawer.style.display = ""

    if (this.mobileMenu) {
      this.mobileMenu.toggleMenu()
    } else if (this.sidedrawer.style.width === this.mobileSidedrawerSize) {
      this.closeMobileVersion()
    } else {
      this.openMobileVersion()
    }
  }

  openMobileVersion() {
    if (this.mobileMenu) {
      this.mobileMenu.openMenu()
    } else {
      this.sidedrawer.style.width = this.mobileSidedrawerSize;
      this.showBackdrop();
    }
  }

  closeMobileVersion() {
    if (this.mobileMenu) {
      this.mobileMenu.closeMenu()
    } else {
      this.sidedrawer.style.width = "0";
      this.hideBackdrop();
    }
  }

  // Verhindert, dass Turbo beim Morphing die vom Library gesetzten Inline-Styles
  // (transform, width, left, ...) am Sidedrawer überschreibt.
  morphElement(event) {
    event.preventDefault()
  }

  showBackdrop() {
    document.querySelector('#backdrop-element').style.display = "block";
  }

  hideBackdrop() {
    document.querySelector('#backdrop-element').style.display = "none";
  }

  clickOutside() {
    if (this.needsToListenToClickOutside) {
      this.closeMobileVersion();
    }
  }

  // Bei kleinen Bildschirmen, wird der Sidedrawer geschlossen wenn ausserhalb geklickt wird
  // Bei Hotwire Native App wird der Sidedrawer immer geschlossen wenn ausserhalb geklickt wird
  get needsToListenToClickOutside() {
    return this.windowWidth <= 768 || isMobileApp;
  }

  get sidedrawer() {
    return this.sidedrawerTarget;
  }
}
